import { SET_BLUETOOTH_DATA } from '../type'

var isLoggedIn = function(str) {
  var bluetooth = JSON.parse(localStorage.getItem('bluetooth'))
  if (bluetooth) {
    return JSON.parse(localStorage.getItem('bluetooth'))[str]
  } else {
    return
  }
}

const state = {
  platform: isLoggedIn('platform') || '',
  deviceId: isLoggedIn('deviceId') || '',
  deviceName: isLoggedIn('deviceName') || '',
  writeCharaterId: isLoggedIn('writeCharaterId') || '',
  writeServiceId: isLoggedIn('writeServiceId') || '',
  notifyCharaterId: isLoggedIn('notifyCharaterId') || '',
  notifyServiceId: isLoggedIn('notifyServiceId') || '',
  readCharaterId: isLoggedIn('readCharaterId') || '',
  readServiceId: isLoggedIn('readServiceId') || '',
  connected: isLoggedIn('connected') || []
}

const mutations = {
  [SET_BLUETOOTH_DATA](state, data) { // 设置蓝牙数据数据
    if (typeof data === 'object') {
      if (Array.isArray(data)) {
        data.forEach(e => {
          // console.log(e.name === 'connected', state.connected)
          if (e.name === 'connected') {
            state.connected.push(e.value)
          } else {
            state[e.name] = e.value
          }
        })
      } else {
        state[data.name] = data.value
      }
      localStorage.setItem('bluetooth', JSON.stringify(state))
    }
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/bluetooth.js